<template>
  <div>
    <mall-header></mall-header>
    <div class="guide-content"></div>
    <div class="invoiceDetails-header" >
    <nav-Menu></nav-Menu>
    <div  class="invoice-div-1" >
        <span class="invoice-div-order" >发票详情</span>
        <span class="invoice-div-break" @click="openInvoiceList" >返回上一级</span>
        <span class="invoice-div-line" ></span>
        <div>
            <span class="invoice-info"  >发票信息 </span>
        </div>

        <div class="invoice-info-div"  >
            <span  class="invoice-info-status" >发票状态：</span>
            <span :class="billingStatus=='2'?'invoice-info-name':'invoice-info-name1'" >   {{billingName}}</span>
            <span class="invoice-info-type" >抬头类型：{{billingTypeName}}</span>
            <span class="invoice-info-company" >公司名称：{{invoiceDetails.billingTitle}}</span>
            <span class="invoice-info-taxpayerNo" >发票税号：{{invoiceDetails.taxpayerNo}}</span>
            <span class="invoice-info-money" >开票金额：</span>
            <span class="invoice-info-billingAmount" >￥{{invoiceDetails.billingAmount}}</span>
            <span class="invoice-info-createTime" >申请时间：{{invoiceDetails.createTime}}</span>
            <div class="invoice-info-img-div" v-if="billingStatus==2">
               <img src="../../static/images/fp.png" @click="opeFP" class="invoice-info-img" />
               <el-button class="invoice-info-button"  @click="uplodFiles()">导出发票</el-button>
            </div>
            <div style="    float: right;margin-top: -88px;margin-right: 195px;"  v-if="billingStatus==2">
              <span class="invoice-info-code">发票代码：{{invoiceDetails.invoiceCode}}</span>
              <span  class="invoice-info-num" >发票号码：{{invoiceDetails.invoiceNum}}</span>
            </div>
        </div>

        <div class="invoice-shopInfo-font" >商品信息</div>
        <div class="invoice-shopInfo-div" v-for="(da, index) in invoiceDetails.orderMasters" :key="index" >
          <div  class="invoice-table-div"   >
                    <span class="invoice-table-time" >申请时间：{{da.createTime}} </span>
                    <span class="invoice-table-No" >订单编号：{{da.orderNo}}</span>
          </div>
          <table class="invoice-table"  v-loading.fullscreen.lock="fullscreenLoading">
              <tr class="invoice-table-tr"  v-for="(data, i) in da.orderDetails" :key="i" >
                <td width=" 620px" style="border: 1px solid #EEEEEE;" >

                    <img :src="data.itemImgUrl" class="invoice-table-img"  @click="openGoodsDetails(data.serviceItemId)"  />
                    <!-- <img :src="datas.orderDetails[0].itemImgUrl" class="orderList-table-td-img" > -->
                    <span  class="invoice-table-td-font"  @click="openGoodsDetails(data.serviceItemId)">{{data.supplierName}}</span>

                    <span class="invoice-table-td-dj" >￥{{data.unitPrice}}</span>
                    <span class="invoice-table-td-num" >{{data.quantity}} 份</span>
                </td>
                <td width=" 150px"  style="border: 1px solid #EEEEEE;    text-align: center;">
                    <span class="invoice-table-td-money" >￥{{data.amount}}</span>
                    <span class="invoice-table-td-type" >共{{data.quantity}}件</span>
                </td>
              </tr>
            </table>
        </div>
        </div>
      <!-- <el-backtop  :bottom="100" style="right: auto;" >
    <div
      style="
        height: 100%;
        width: 100%;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 40px;
        color: #1989fa; ">
      <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
    </div>
  </el-backtop> -->
    </div>
     <mall-footer ></mall-footer>
  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import http from '../api/public'
import axios from 'axios'
import $ from 'jquery'
  export default {
    data () {
      return {
        invoiceDetails:{},
        mdShow:false,
        payShow:true,
        selectType:"",
        payC:false,
        activeName: 'first',
        billingTypeName:"",
        billingName:"",
        billingStatus:"",
        fileUrl:"",
        fpImage:"",
        totalPrice:'',
        orId:'',
         fullscreenLoading:true,
        minute:"29",
        second:"59",
        afterEqual:"",
       invoiceTotal:0,
        querydata:{
          pageNo:1,//初始显示第几页
          pageSize:4//每页显示多少数据
        },
        channel:"",
        payList:[]
      }
    },
    mounted() {
      //发票详情信息
       this.getOrderDetials();
    },
    methods: {
      //发票详情信息
      getOrderDetials() {
        let afterUrl =  window.location.hash.substring(1);
        if(afterUrl){
            let str = afterUrl.indexOf('=')+1
            this.afterEqual = afterUrl.substring(str).toUpperCase();
        }else{
            this.afterEqual = this.$route.query.orderId
        }
        axios.get('/mallApi/mall/invoiceRecord/queryById?id='+this.afterEqual,{headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          this.fullscreenLoading=false;
          if(res.success){
            this.invoiceDetails  = res.result;
            this.fileUrl = res.result.attachs
            this.fpImage = "/mallApi/"+decodeURI(this.fileUrl)
            this.titelName(this.invoiceDetails.billingType);
            this.billingStatusName(this.invoiceDetails.billingStatus);
            this.billingStatus =  this.invoiceDetails.billingStatus;
            this.invoiceDetails.billingAmount  = http.changeUnitPrice(this.invoiceDetails.billingAmount);
            let  inoviceDa = this.invoiceDetails;
             inoviceDa.orderMasters.forEach(da => {
                da.orderDetails.forEach(d => {
                  d.itemImgUrl =  "/mallApi"+d.itemImgUrl;
                    d.unitPrice = http.changeUnitPrice(d.unitPrice);
                    d.amount = http.changeUnitPrice(d.amount);
                });
                //console.log( da.unitPrice);
              });
          }else{
             if(res.code == 401|| res.code == 400) {
                http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message(res.message);
              }
          }
        });
      },
      //发票抬头类型转换
       titelName(billingType){
        switch(billingType) {
          case "1":
             this.billingTypeName= "企业单位"
              break
          case "2":
              this.billingTypeName=  "个人/非企业单位"
               break
          default:
             this.billingTypeName=  ""
              break
        }
      },
      //发票开票状态转换
      billingStatusName(billingStatus){
        switch(billingStatus) {
          case "1":
             this.billingName="待开票"
             break
          case "2":
               this.billingName="已开票"
                break
           case "3":
               this.billingName="已取消"
                break
          default:
               this.billingName=""
                break
        }
      },
      //进入发票列表
     openInvoiceList(){
         this.$router.push({ path:'/invoiceList' })
     },
     //打开发票pdf 文件
      opeFP(){
          window.open("/mallApi/"+decodeURI(this.fileUrl));
      },
      //下载发票pdf 文件
      uplodFiles(url,filename){
        let a = document.createElement('a');
        a.href = "/mallApi/"+this.fileUrl;
        a.download = this.fileUrl;
        a.click();
      },
      //查看商品详情
     openGoodsDetails(id){
        window.open("#/GoodsDetails?id="+id);
     },
      //分页当前页change 事件
      handleCurrentChange(currentPage){
        this.querydata.pageNo = currentPage;

        this.getInvoiceData();
      },
      //分页当前条数 change 事件
      handleSizeChange(pagesize){
        console.log(pagesize)
        this.querydata.pageSize = pagesize;
        //this.form.size = val;
        this.getInvoiceData();

      },

      handleClick(tab, event) {
        console.log(tab, event);
      },
      //订单支付状态转换
      statusName(){
        switch(this.orderData.status) {
          case "1":
              this.orderData.statusName = "待支付"
              break;
          case "2":
              this.orderData.statusName = "已支付"
              break;
          case "3":
              this.orderData.statusName = "已取消"
              break;
          default:
              this.orderData.statusName=""
              break;
        }
      },
      //业务购买类型转换
       typeName(){
          switch(this.orderData.status) {
            case "1":
                this.orderData.typeName = "线下购买"
                break;
            case "2":
                this.orderData.typeName = "在线充值"
                break;
            case "3":
                this.orderData.typeName = "活动赠送"
                break;
            case "4":
                this.orderData.typeName="消费返点"
                break;
            default:
                this.orderData.typeName="消费返点"
                break;
          }
      }
    },
    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      http
    }
  }
</script>
<style lang="scss" scoped>
  @import "../assets/style/mixin";
  .invoiceList-div  div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}

.el-button.order-button-again.el-button--default:hover {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    opacity: 0.6;
    color: #287EFF;
}
.order-button-again:active{

  background: rgba(40, 126, 255, 0.1);
  border: 1px solid #287EFF;
  border-radius: 4px;
}
.el-pagination__sizes .el-input .el-input__inner:hover {
    border-color: #287EFF!important;
}

  .invoiceDetails-header{
    overflow-x: auto; min-width: 1200px;   width: 1200px;margin: 0 auto;
  }
  .invoice-div-1{
    margin-left: 220px;
    width: 980px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    margin-top: -360px;
    float: left;
    overflow: auto;
  }

  .invoice-div-1  div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
  .invoice-div-order{
    height: 16px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    float: left;
    margin-left: 30px;
    margin-top: 20px;
  }
  .invoice-info{
        margin-left: 30px;
    vertical-align: top;
    margin-top: 30px;
    float: left;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    line-height: 20px;
  }
  .invoice-info-div{
      width: 920px;
      height: 304px;
      background: white;
      border: 1px solid #eeeeee;
      float: left;
      margin-top: 20px;
      margin-left: 30px;
  }
  .invoice-info-status{
      display: block;
      margin-left: 30px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-top: 20px;
  }
  .invoice-info-name{
    display: block;
    margin-top: -20px;
    margin-left: 120px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #4CAF50;
    line-height: 20px;
  }
  .invoice-info-name1{
    display: block;
    margin-top: -20px;
    margin-left: 120px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
  }
  .invoice-info-type{
    display: block;
    margin-left: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
    margin-top: 30px;
  }
  .invoice-info-company{
    display: block;
    margin-left: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .invoice-info-taxpayerNo{
    display: block;
    margin-left: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .invoice-info-money{
    display: block;
    margin-left: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 36px;
  }
  .invoice-info-billingAmount{
    float: left;margin-left: 95px;margin-top: -28px;color: #FF620E;font-size: 14px;font-family: PingFang SC;font-weight: 500;
  }
  .invoice-table{
      margin-left: 30px; width: 97%;height: 110px;background: #FFFFFF;border: 1px solid #EEEEEE;
  }
  .invoice-info-createTime{
      display: block;
      margin-left: 30px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 36px;
  }
  .invoice-table-div{
       width: 97%;height: 40px;background: #F6F6F6;margin-top: -10px;border: 1px solid #EEEEEE; margin-left: 30px;
  }
  .invoice-table-time{
     // margin-left: 30px;position: absolute;margin-top: 10px
     margin-left: 30px;
    float: left;
    margin-top: 10px;
  }
  .invoice-table-No{
    margin-left: 60px;
    float: left;
    margin-top: 10px;
  }
  .invoice-table-img{
    //cursor: pointer;   margin-left: 25px;width: 68px;height: 68px;background: radial-gradient(circle, #391DB4, #241093);
    cursor: pointer;
    margin-left: 30px;
    width: 68px;
    float: left;
    height: 68px;
    background: radial-gradient(circle, #391DB4, #241093);
  }
  .invoice-table-tr{
    height: 110px;border: 1px solid #EEEEEE;
  }
  .invoice-info-code{
    display: block;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgb(102, 102, 102);
    line-height: 36px;
    //margin-right: 190px;
  }
  .invoice-info-num{
    display: block;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgb(102, 102, 102);
    line-height: 36px;
    //float: right;
    //margin-right: 200px;
  }
  .invoice-info-button{
      float: right;
      width: 120px;
      height: 40px;
      background: rgb(255, 255, 255);
      border: 1px solid rgb(221, 221, 221);
      border-radius: 4px;
      margin-right: 56px;
      margin-top: -178px;
  }
  .invoice-info-img-div{
      float: right;margin-right: 0px;
  }
  .invoice-info-img{
    float: right;
    width: 150px;
    height: 96px;
    margin-right: 215px;
    margin-top: -200px;
    cursor: pointer;
    border: 1px solid #EEEEEE;
  }
  .invoice-div-break{
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    width: 70px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #287EFF;
    line-height: 20px;
    cursor: pointer;
  }
 .invoice-div-break:hover{text-decoration: underline;border-bottom:2px; color:#287EFF }
  .invoice-div-line{
    width: 100%;
    border-bottom: 1px solid #EEEEEE;
    height: 1px;
    margin-top: 20px;
    margin-left: 0px;
    float: left;
  }

.invoice-shopInfo-div{
  float: left;
    margin-top: 30px;
    width: 950px;
    margin-left: 0px;
    margin-right: 30px;
    margin-bottom: 30px;
}

.invoice-table-td-font {
    cursor: pointer;
    float: left;
    margin-left: 30px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    padding-top: 23px;
    color: #333333;
}
.invoice-table-td-font:hover{color: #287eff}
.invoice-table-td-dj {
    margin-left: 240px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    float: left;
    padding-top: 30px;
}
.invoice-table-td-num {
    margin-top: -18px;
    margin-left: 490px;
    float: left;
    height: 12px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 20px;
}
.invoice-table-td-money {
    margin-top: 15px;
    height: 13px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
}
.invoice-table-td-type {
    display: block;
    //margin-top: 35px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 20px;
}

  .invoice-shopInfo-font{
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    line-height: 20px;
    margin-left: 30px;
    margin-top: 30px;
    float: left;
  }

</style>



// WEBPACK FOOTER //
// InvoiceDetails.vue?7f241936